import { v4 as uuid } from 'uuid';

export const cards = [
  {
    _card: 1,
    id: uuid(),
    maxHeight: 520,
    mobileHeight: 430,
    front: [
      {
        label: 'Description',
        content:
          'Asking friends, family, neighbors, mentors, or community members (e.g., social clubs, faith-based groups, online forums, library)',
      },
    ],
    back1: [
      {
        label: 'Source',
        content: 'Social circles',
        style: { color: '#000' },
      },
    ],
    back2: [
      {
        label: 'Benefit',
        content:
          'Reach people who already trust you and who are open to discussing their motivations, desires, and goals',
        style: { color: '#000' },
      },
    ],
  },
  {
    _card: 2,
    id: uuid(),
    maxHeight: 460,
    mobileHeight: 360,
    front: [
      {
        label: 'Description',
        content: 'Asking coworkers or managers from past or current jobs',
      },
    ],
    back1: [
      {
        label: 'Source',
        content: 'Professional circles',
        style: { color: '#000' },
      },
    ],
    back2: [
      {
        label: 'Benefit',
        content: 'Reach relevant and sometimes hard-to-access interview participants',
        style: { color: '#000' },
      },
    ],
  },
  {
    _card: 3,
    id: uuid(),
    maxHeight: 460,
    mobileHeight: 390,
    front: [
      {
        label: 'Description',
        content:
          'Posting on platforms (e.g., LinkedIn, Slack, etc.) to recruit people who fit the target audience you’re designing for',
      },
    ],
    back1: [
      {
        label: 'Source',
        content: 'Social networks',
        style: { color: '#000' },
      },
    ],
    back2: [
      {
        label: 'Benefit',
        content: 'Reach a wide audience with a single post',
        style: { color: '#000' },
      },
    ],
  },
  {
    _card: 4,
    id: uuid(),
    maxHeight: 490,
    mobileHeight: 390,
    front: [
      {
        label: 'Description',
        content:
          'Positioning yourself in a place you’re likely to encounter your target audience (e.g., a dog park or coffee shop)',
      },
    ],
    back1: [
      {
        label: 'Source',
        content: 'Hallway testing',
        style: { color: '#000' },
      },
    ],
    back2: [
      {
        label: 'Benefit',
        content: 'Reach your target audience in a familiar, natural environment',
        style: { color: '#000' },
      },
    ],
  },
  {
    _card: 5,
    id: uuid(),
    maxHeight: 500,
    mobileHeight: 410,
    front: [
      {
        label: 'Description',
        content:
          'Using the Coursera discussion forum to reach out to fellow learners in this program who fit the target audience you’re designing for',
      },
    ],
    back1: [
      {
        label: 'Source',
        content: 'Course peers',
        style: { color: '#000' },
      },
    ],
    back2: [
      {
        label: 'Benefit',
        content: 'Help each other learn and improve your user interview skills together',
        style: { color: '#000' },
      },
    ],
  },
  {
    _card: 6,
    id: uuid(),
    maxHeight: 470,
    mobileHeight: 370,
    front: [
      {
        label: 'Description',
        content:
          'Companies or tools that source participants for user research studies like UserTesting or User Interviews',
      },
    ],
    back1: [
      {
        label: 'Source',
        content: 'Recruiting agencies',
        style: { color: '#000' },
      },
    ],
    back2: [
      {
        label: 'Benefit',
        content: 'Save time and reach diverse users',
        style: { color: '#000' },
      },
    ],
  },
  {
    _card: 7,
    id: uuid(),
    maxHeight: 520,
    mobileHeight: 410,
    front: [
      {
        label: 'Description',
        content:
          "Asking people who currently use or previously used the product you're designing for (e.g., talking to customer support, accessing an email list)",
      },
    ],
    back1: [
      {
        label: 'Source',
        content: 'Existing user base',
        style: { color: '#000' },
      },
    ],
    back2: [
      {
        label: 'Benefit',
        content: 'Reach people who are already part of the target audience',
        style: { color: '#000' },
      },
    ],
  },
];
